// Module for creating international urls
// Usage:
// var intlUrl = require('./modules/intl-url')('/destination/path');

module.exports = function intlUrl(url) {
  var isChinaSite = require('./is-yxbj')();
  var language = document.getElementsByTagName('html')[0].getAttribute('lang');
  if (language !== 'en' && language !== 'ja' && !isChinaSite) {
    return '/intl/' + language + url;
  } else if (language === 'ja') {
    return '/intl/jp' + url;
  }
  return url;
};



// WEBPACK FOOTER //
// ./webroot/yinxiang/media/js/modules/intl-url.js